import type { FC, PropsWithChildren } from "react";

import { ThemeProvider } from "@mui/material/styles";

import CssBaseline from "@mui/material/CssBaseline";
import GlobalStyles from "@mui/material/GlobalStyles";

import { brandTheme } from "./MuiThemeProvider.constants";
import { brandColorTokens } from "@constants/brandColors";

import "@css/brandFonts.css";

const MuiThemeProvider: FC<PropsWithChildren> = ({ children }) => (
  <ThemeProvider theme={brandTheme}>
    <CssBaseline enableColorScheme={true} />
    <GlobalStyles
      styles={{
        ":where(a)": { color: "inherit", textDecoration: "underline" },
        ":where(a:hover)": { color: brandColorTokens.text.linkHover },
      }}
    />
    {children}
  </ThemeProvider>
);

export default MuiThemeProvider;
